import { useTranslation } from "src/context/Translations/context";
import React from "react";
import {  RCCCheckBox, RCCGrid, RCCInput, RCCTextArea } from "react-common-components";
import DateTimePicker from "src/components/DateTimePicker";
import LovSectors from "src/components/Lov/Sectors";
import LovUsers from "src/components/Lov/Users";
import LovRequirementsOccurrences from "src/components/Lov/RequirementsOccurrences";
import LovOriginOccurrences from "src/components/Lov/OriginOccurrences";
import CategoriesOccurrences from "src/components/Lov/CategoriesOccurrences";
import { useAuth } from "src/context/Auth/context";
import { IFormSimplifiedFields } from "./interface";


const FormSimplifiedFields: React.FC<IFormSimplifiedFields> = ({
	occurrence,
	control,
	error,
	register
}) => {

	const { translate } = useTranslation();
	const { user } = useAuth();


	const defaultValue = (value: any, label: any) => {
		if(label && value)
			return { value: String(value), label};

		if(value)
			return value.toString();

		return "";
	};


	return (
		<>
			<RCCGrid
				container
				item
				direction="column"
				alignItems="center"
			>				
				<RCCGrid
					container
					item		
				>
					<RCCInput 
						name="ocb001Codigo"
						label={translate("Código")}
						maxLength={40}
						register={register}
						defaultValue={occurrence.ocb001Codigo}
						error={error.ocb001Codigo}
					/>
				</RCCGrid>

				<RCCGrid
					container
					item		
				>
					<RCCInput 
						name="ocb001Titulo"
						label={translate("Título")}
						maxLength={200}
						register={register}
						defaultValue={occurrence.ocb001Titulo}
						error={error.ocb001Titulo}
						required
					/>
				</RCCGrid>
				<RCCGrid
					container
					item		
				>
					<RCCTextArea 
						name="ocb001Descricao"
						label={translate("Descrição")}
						maxLength={4000}	
						register={register}
						defaultValue={occurrence.ocb001Descricao}
						error={error.ocb001Descricao}
						required
					/>
				</RCCGrid>
				<RCCGrid
					container
					item		
				>
					<DateTimePicker 
						label={translate("Data")}
						name="ocb001Data"
						type="datePicker"
						control={control}
						defaultValue={occurrence.ocb001Data ?? new Date()}
						error={error.ocb001Data}
					/>
				</RCCGrid>
				<RCCGrid
					container
					item		
				>
					<LovSectors 
						control={control}
						name="ocb001Taa001Id"
						label={translate("Setor")}
						defaultValue={defaultValue(occurrence.ocb001Taa001Id, occurrence.ocb001Taa001Descricao)}
						required
						isCreatable
						error={error.ocb001Taa001Id}
					/>
				</RCCGrid>	
				<RCCGrid
					container
					item		
				>
					<LovUsers 
						control={control}
						name="ocb001Efa005Id"
						label={translate("Operador")}
						error={error.ocb001Efa005Id}
						defaultValue={occurrence.ocb001Efa005Id ? defaultValue(occurrence.ocb001Efa005Id, occurrence.ocb001Efa005Nome) : {
							value: user.efa005Id.toString(),
							label: user.efa005Nome
						}}
						required
					/> 
				</RCCGrid>
				<RCCGrid
					container
					item		
				>
					<LovRequirementsOccurrences 
						control={control}
						name="ocb001Oca001Id"
						label={translate("Requisito")}
						error={error.ocb001Oca001Id}
						defaultValue={defaultValue(occurrence.ocb001Oca001Id, occurrence.oca001Descricao)}
						required
					/>
				</RCCGrid>
				<RCCGrid
					container
					item		
				>
					<LovOriginOccurrences 
						control={control}
						name="ocb001Oca002Id"
						error={error.ocb001Oca002Id}
						label={translate("Origem")}
						defaultValue={defaultValue(occurrence.ocb001Oca002Id, occurrence.oca002Descricao)}
						required
					/>
				</RCCGrid>
				<RCCGrid
					container
					item		
				>
					<CategoriesOccurrences 
						control={control}
						name="ocb001Oca004Id"
						label={translate("Categoria")}
						error={error.ocb001Oca004Id}
						defaultValue={defaultValue(occurrence.ocb001Oca004Id, occurrence.oca004Descricao)}
						required
					/>
				</RCCGrid>
				<RCCGrid
					container
					item
					xs={12}
				>
					<RCCGrid
						container
						item
						xs={12}
						sm={6}
					>
						<LovUsers 
							control={control}
							name="ocb001Efa005Id4"
							label={translate("Responsável")}
							defaultValue={occurrence.ocb001Efa005Id4 ? occurrence.ocb001Efa005Id4.toString() : user.efa005Id.toString()}
							error={error.ocb001Efa005Id4}
							required
						/>
					</RCCGrid>
					<RCCGrid
						container
						item
						xs={12}
						sm={5}
					>
						<RCCCheckBox 
							name="ocb001NotificaResponsavel"
							defaultChecked={occurrence.ocb001NotificaResponsavel !== "N"}
							label={translate("Acompanhar andamento")}
							labelPosition="end"
							register={register}
							styleInline={{checkbox: "padding-left: 5%;"}}
							error={error.nameOfCheckbox}
						/>
					</RCCGrid>
				</RCCGrid>
				{/* Accountable */}
				<RCCGrid
					container
					item
					xs={12}
				>
					<RCCGrid
						container
						item
						xs={12}
						sm={6}
					>
						<LovUsers 
							control={control}
							name="ocb001Efa005Id3"
							label={translate("Autoridade")}
							defaultValue={occurrence.ocb001Efa005Id3 ? occurrence.ocb001Efa005Id3.toString() : user.efa005Id.toString()}
							error={error.ocb001Efa005Id3}
							required
						/>
					</RCCGrid>
					<RCCGrid
						container
						item
						xs={12}
						sm={5}
					>
						<RCCCheckBox 
							name="ocb001NotificaAutoridade"
							defaultChecked={occurrence.ocb001NotificaAutoridade !== "N"}
							label={translate("Acompanhar andamento")}
							labelPosition="end"
							register={register}
							error={error.ocb001NotificaAutoridade}
							styleInline={{checkbox: "padding-left: 5%;"}}
						/>
					</RCCGrid>
				</RCCGrid>
			</RCCGrid>
		</>
	);
};

export default FormSimplifiedFields;
